"use client";

import { c as _c } from "react/compiler-runtime";
import { useCurrentRefinements, useInstantSearch } from "react-instantsearch";
import { PRODUCTS_INDEX_NAME } from "@/lib/search/instantsearchClient";
import { ALL_FACETS } from "@/lib/search/queryConfig";
import { useFilterGroups } from "./PlpFilterGroupsContext";
import { type PlpFilterPill, PlpFilterPillBar, type SearchPill } from "./PlpFilterPillBar";
interface Props {
  excludedAttributes?: string[];
  searchPill?: SearchPill;
}
const NO_EXCLUSIONS: string[] = [];
export function PlpCurrentRefinementsPills(t0) {
  const $ = _c(13);
  const {
    excludedAttributes,
    searchPill
  } = t0;
  const excluded = excludedAttributes ?? NO_EXCLUSIONS;
  const groups = useFilterGroups();
  let t1;
  if ($[0] !== groups) {
    t1 = new Map(groups.map(_temp));
    $[0] = groups;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const attributeLabels = t1;
  const valueLabelByKey = new Map();
  for (const group_0 of groups) {
    for (const value of group_0.values) {
      valueLabelByKey.set(`${group_0.slug}:${value.productAttributeKey}`, value.label);
    }
  }
  let t2;
  if ($[2] !== excluded) {
    t2 = {
      excludedAttributes: [...excluded, "query"]
    };
    $[2] = excluded;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    items,
    refine
  } = useCurrentRefinements(t2);
  const {
    setUiState
  } = useInstantSearch();
  let t3;
  if ($[4] !== excluded) {
    t3 = ALL_FACETS.filter(attr => !excluded.includes(attr));
    $[4] = excluded;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const attributesToClear = t3;
  const valueLabel = function valueLabel(attribute, value_0) {
    return valueLabelByKey.get(`${attribute}:${value_0}`) ?? String(value_0);
  };
  const formatPillLabel = function formatPillLabel(attribute_0, value_1) {
    const display = valueLabel(attribute_0, value_1);
    if (attribute_0 === "productType") {
      return display;
    }
    const prefix = attributeLabels.get(attribute_0) ?? attribute_0;
    return `${prefix}: ${display}`;
  };
  let t4;
  if ($[6] !== attributesToClear || $[7] !== setUiState) {
    t4 = function handleClearAll() {
      setUiState(prev => {
        const indexState = prev[PRODUCTS_INDEX_NAME] ?? {};
        const refinementList = {
          ...(indexState.refinementList ?? {})
        };
        for (const attr_0 of attributesToClear) {
          delete refinementList[attr_0];
        }
        const {
          query: _query,
          ...rest
        } = indexState;
        return {
          ...prev,
          [PRODUCTS_INDEX_NAME]: {
            ...rest,
            refinementList
          }
        };
      });
    };
    $[6] = attributesToClear;
    $[7] = setUiState;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleClearAll = t4;
  const pills = items.flatMap(item => item.refinements.map(refinement => ({
    id: `${refinement.attribute}-${refinement.value}`,
    label: formatPillLabel(refinement.attribute, refinement.value),
    onRemove: () => refine(refinement)
  })));
  const hasActive = pills.length > 0 || searchPill !== undefined;
  const onClearAll = hasActive ? handleClearAll : undefined;
  let t5;
  if ($[9] !== onClearAll || $[10] !== pills || $[11] !== searchPill) {
    t5 = <PlpFilterPillBar pills={pills} searchPill={searchPill} onClearAll={onClearAll} />;
    $[9] = onClearAll;
    $[10] = pills;
    $[11] = searchPill;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp(group) {
  return [group.slug, group.label];
}